$(document).ready(function () {
    $('[data-mask=phone]').inputmask({
        mask: function (el) {
            return [
                '+7 999 999-99-99',
                '+399 99 999-99-99',
                ]
        },
    })

    $('.select2').select2({
        'dropdownPosition': 'below',
    })

    window.update_select2 = function ($container) {
        $container.find('.select2').select2()
    }

    var lastScrollTop = 0
    var lastTimestamp = 0
    $(window).on('scroll', function (e) {
        if (lastTimestamp) {
            var st = $(this).scrollTop()
            var $header = $('header')
            if (st < lastScrollTop && st > $header.height()) {
                var velocity = (st - lastScrollTop) / (e.timeStamp - lastTimestamp)
                if (velocity < -1) {
                    $header.addClass('header__fixed')
                }
            }
            else {
                $header.removeClass('header__fixed')
            }
            lastScrollTop = st
        }
        lastTimestamp = e.timeStamp
    })
})
